import { motion } from "framer-motion";

const reveal = {
  initial: { opacity: 0, y: 40 }, whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] },
};

const ARTICLES = [
  { cat: "Review", date: "FEB · 2026", title: "The Genesis G70: A Cinematic Argument", img: "https://images.unsplash.com/photo-1623346483743-b968a27ed34c?w=1400&q=85", excerpt: "Why the G70 might be the most filmable luxury sedan of the decade. Notes from a week of shooting at 3 AM." },
  { cat: "Process", date: "JAN · 2026", title: "Behind Nocturne · Issue 01", img: "https://images.unsplash.com/photo-1610374634235-b51ef357f905?w=1400&q=85", excerpt: "On building a magazine without a magazine. And why the empty boulevard is our favorite studio." },
  { cat: "Culture", date: "DEC · 2025", title: "Vintage Porsche, Eternal Patina", img: "https://images.pexels.com/photos/36427283/pexels-photo-36427283.jpeg?w=1400", excerpt: "Time, weather and the case for old metal in luxury photography." },
];

export default function Journal() {
  return (
    <main data-testid="journal-page" className="bg-black pt-32 pb-24">
      <section className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 mb-20">
        <motion.p {...reveal} className="overline mb-6">The Good Bandit Journal</motion.p>
        <motion.h1 {...reveal} className="font-display text-6xl md:text-8xl text-white leading-[0.95]">
          Journal <span className="italic text-[var(--gb-gold)]">/</span> 2026
        </motion.h1>
        <motion.p {...reveal} className="text-white/60 text-base md:text-lg max-w-xl mt-10 leading-relaxed">
          Reviews, behind the scenes notes, car culture and our creative process. Read like an editorial.
        </motion.p>
      </section>

      <section className="max-w-[1100px] mx-auto px-6 md:px-12 space-y-32">
        {ARTICLES.map((a, i) => (
          <motion.article {...reveal} key={i} data-testid={`journal-article-${i}`} className="grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
            <div className="md:col-span-12 aspect-[16/9] overflow-hidden">
              <img src={a.img} alt={a.title} className="w-full h-full object-cover" />
            </div>
            <div className="md:col-span-3">
              <p className="kbd">{a.cat}</p>
              <p className="kbd mt-2 text-white/40">{a.date}</p>
            </div>
            <div className="md:col-span-9">
              <h2 className="font-display text-4xl md:text-5xl text-white leading-[1.05]">{a.title}</h2>
              <p className="text-white/65 leading-[1.8] mt-6 text-lg max-w-2xl">{a.excerpt}</p>
              <button className="gb-link mt-6 text-[var(--gb-gold)] text-xs uppercase tracking-[0.25em]">Read article →</button>
            </div>
          </motion.article>
        ))}
      </section>
    </main>
  );
}
